import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { ResolvedContent } from "@/molecules/IssueStatusTag"

import styles from "../IssueStatusAlert.module.scss"

import type { Issue } from "@/domain/issue"

export const ResolvedMeta = (props: { record: Issue }) => {
  const { record } = props
  const { t } = useTranslation()

  return (
    <Flex className={styles.meta}>
      <ResolvedContent component="alert" record={record} t={t} />
    </Flex>
  )
}
